function setPathNameToStorage(key, value){
    localStorage.setItem(key,value)
}

function getPathNameToSorage(key){
    if(localStorage.getItem(key) === null){
        return `${key} no coincide o no existe`
    }
    return localStorage.getItem(key)
}

export{setPathNameToStorage, getPathNameToSorage}